import { render, staticRenderFns } from "./SeniorMembersRegionEdit.vue?vue&type=template&id=b39da994&scoped=true"
import script from "./SeniorMembersRegionEdit.vue?vue&type=script&lang=js"
export * from "./SeniorMembersRegionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39da994",
  null
  
)

export default component.exports